import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Banner = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  box-sizing: border-box;
  background: rgba(80, 80, 120, 0.25);
  color: var(--text-color, #ccc);
  font-size: 0.8rem;
  text-align: center;
  z-index: 199;
`;

const Countdown = styled.span`
  font-variant-numeric: tabular-nums;
  font-weight: 600;
`;

/**
 * Small banner above the input shown only while progressive-trust
 * restrictions are active (driven by the server's `trust_status` event).
 * During the read-only window the user can still compose — only sending is
 * held — so the copy frames it as a short wait, not a block.
 */
function TrustBanner({ readOnlyUntil, slowModeSeconds, restrictions = [] }) {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (!readOnlyUntil || readOnlyUntil <= Date.now()) {
      setSecondsLeft(0);
      return undefined;
    }
    const tick = () => {
      const remaining = Math.max(0, Math.ceil((readOnlyUntil - Date.now()) / 1000));
      setSecondsLeft(remaining);
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [readOnlyUntil]);

  if (secondsLeft > 0) {
    return (
      <Banner>
        Welcome! You can read and type now — sending unlocks in{' '}
        <Countdown>{secondsLeft}s</Countdown>
      </Banner>
    );
  }

  if (restrictions.includes('slow_mode') && slowModeSeconds) {
    return (
      <Banner>
        Slow mode: one message every {slowModeSeconds}s while your account is new
      </Banner>
    );
  }

  return null;
}

export default TrustBanner;
